import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { FlexItemProps } from "@/types";
import { useMargins } from "@/hooks";


/**
 * A generic flex box child.
 */
const __default__ = {
  name: "FlexItem",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    parts: {},
    fullWidth: { type: Boolean },
    x: {},
    y: {},
    l: {},
    r: {},
    t: {},
    b: {}
  },
  setup(__props: any) {

const props = __props;

const className = useMargins(props, () => [
  ["parts", `col-${props.parts}`],
  ["fullWidth", "full-width"],
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(className))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})